import { WebStorageStateStore } from "oidc-client-ts";

// Helper variables derived from your existing environment variables
const authority = process.env.REACT_APP_COGNITO_AUTHORITY; // Expected: https://cognito-idp.<region>.amazonaws.com/<user-pool-id>
const customDomain = "https://auth.kloudscan.com"; // Replace with your env variable or hardcoded custom domain

const loginAuthConfig = {
  authority: authority,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI,
  response_type: "code",
  scope: "email openid profile",
  useRefreshToken: true,
  automaticSilentRenew: true,
  loadUserInfo: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),

  // Explicitly override endpoints to bypass Cognito's custom domain discovery limitations
  metadata: {
    issuer: authority,
    authorization_endpoint: `${customDomain}/oauth2/authorize`,
    token_endpoint: `${customDomain}/oauth2/token`,
    userinfo_endpoint: `${customDomain}/oauth2/userInfo`,
    end_session_endpoint: `${customDomain}/logout`,

    // REQUIRED FOR TOKEN VALIDATION: Tells the library where to get public keys to verify the JWTs
    jwks_uri: `${authority}/.well-known/jwks.json`,

    // REQUIRED BY OIDC-CLIENT-TS: Informs the library of the token signing algorithm
    id_token_signing_alg_values_supported: ["RS256"],
  },
};

export default loginAuthConfig;
